import styled from 'styled-components'
import React from 'react'
import PropTypes from 'prop-types'

const LoadingPlaceholderStyled = styled.div`
    animation-name: opacityAnimation;
    animation-duration: 1.2s;
    animation-iteration-count: infinite;
    text-align: center;
    width: 100%;
    overflow: hidden;
    @keyframes opacityAnimation {
        0% {
            opacity: 0.4;
        }
        25% {
            opacity: 0.2;
        }
        100% {
            opacity: 0.4;
        }
    }

`

const PlaceholderContainer = ({ children }) => (
    <LoadingPlaceholderStyled>{ children }</LoadingPlaceholderStyled>
)

PlaceholderContainer.propTypes = {
    children: PropTypes.any,
}

export default PlaceholderContainer
